
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';

import { ApiAuthService } from '@services/api-auth.service';
import { SharedService } from '@services/shared.service';

import { environment } from '@environments/environment';
import { SessionModel } from '@shared/models/SessionModel';
import { CustomerType } from '@shared/models/Enums';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    templateUrl: './blank.component.html',
    styleUrls: ['./blank.component.scss']
})
export class BlankComponent implements OnInit, OnDestroy {

    @ViewChild(PerfectScrollbarDirective, { static: true }) directiveRef?: PerfectScrollbarDirective;
    @ViewChild('updateAvailable', { static: true }) updateAvailableModal: any;

    color = 'red';

    public config: PerfectScrollbarConfigInterface = {};

    private logoutSubscription: Subscription = null;

    isDesktop = true;
    showLandingPage = false;
    isApp = true;
    showPreLogin = false;

    constructor(private router: Router,
        public breakpointObserver: BreakpointObserver,
        private apiAuthService: ApiAuthService,
        public sharedService: SharedService,
        private modalService: NgbModal) {

        // valida si es tablet
        this.breakpointObserver
            .observe(['(max-width: 1024px)'])
            .subscribe((state: BreakpointState) => {
                if (state.matches) {
                    this.isDesktop = false;
                } else {
                    this.isDesktop = true;
                }
            });
    }

    ngOnInit() {

        // Canvas Mobiloud App
        this.isApp = navigator.userAgent.toLowerCase().indexOf('canvas') > -1;

        if (environment.production) {
            // Acceso dentro del app Mobiloud
            if (this.isApp) {

                this.modalService.open(this.updateAvailableModal, {
                    backdrop: 'static', keyboard: false,
                    size: 'md', centered: true, windowClass: 'modal-full'
                });

                // Se oculta el landing page
                this.showLandingPage = false;
            }
            // Acceso desde web en giviapp.com o holagivi.com
            else {

                // Default se muestra el landing page
                this.showLandingPage = true;
                this.showPreLogin = false;

                // HolaGivi: para aceptar Givis
                const urls = this.router.url.split('/').filter(x => x);
                // Valida si tiene que ocultar el landing page
                if (urls.some(x => x == 'transferircupon' || x == 'tb' || x == 'transferirgivi' ||
                    x == 'tc' || x == 'tg' || x == 'tt' || x == 'nuevogivi' || x == 'ng' ||
                    x == 'checkout' || x == 'pack' || x == 'form'  || x == 'plan' || x == 'apps' || x == 'app-links' ||
                    x == 'givipops' || x == 'vendor-form'  || x == 'scratch-sticker' || x == 'scratch')) {
                    // Solo se oculta si esta recibiendo un givi
                    this.showLandingPage = false;
                }
                return;
            }
        } else {

            // Se oculta el landing page
            this.showLandingPage = false;
        }

        // La raspadita publica (link tradicional y sticker link) funciona con o sin sesion:
        // si el usuario acaba de registrarse desde la raspadita y refresca, no lo mandemos a
        // completar perfil (rompería el flujo).
        const firstSegment = this.router.url.split('/').filter(x => x)[0];
        const isPublicScratchRoute = firstSegment === 'scratch' || firstSegment === 'scratch-sticker';

        // Esto se utiliza para redirigir automáticamente al usuario a la página de market si ya tiene una sesión
        const session = this.apiAuthService.getSession();
        if (session && session.accessToken?.length > 0 && !isPublicScratchRoute) {

            //this.showPreLogin = true;
            // Llamada asíncrona al login o registro
            this._goToLogged(session);
        } else {

            this.showPreLogin = false;
        }

        // subscribe and tracking the logout state
        this.logoutSubscription = this.sharedService.logoutSubject.subscribe(() => {

            this.apiAuthService.logout(this.router);
        });
    }

    ngOnDestroy() {

        if (this.logoutSubscription) { this.logoutSubscription.unsubscribe(); }
    }

    onUpdate() {
        
        const userAgent = navigator.userAgent || navigator.vendor;

        let os: string | null = null;

        // Valida con regex si el usuario está en un dispositivo Android o iOS
        if (/android/i.test(userAgent)) {
            os = 'Android';
        } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
            os = 'iOS';
        }

        if (os === 'Android') {
            window.open('https://play.google.com/store/apps/details?id=com.Givi.android');
        } else if (os === 'iOS') {
            window.open('https://apps.apple.com/us/app/givi-regalos-por-un-mensaje/id6443953772');
        }
    }


    private _goToLogged(session: SessionModel) {

        const loggedIn = (session?.accessToken != null);
        if (loggedIn) {

            if (session.user.type != CustomerType.GiviScan) {
                /* Verifica si nombre del usuario aun no se ha completado. 
                Si falta el nombre o apellido, provincia, cantón y distrito del usuario se lleva al usuario a la página de información de la
                cuenta (`/registro/cuenta`) para pedirle que proporcione su nombre y apellido, provincia, cantón y distrito. */
                if (!session.user.name || !session.user.lastName || !session.user.province || !session.user.canton) {

                    this.showPreLogin = false;
                    return this.router.navigate(['/registro/cuenta']);
                }
            }
            // Se utiliza para navegar al marketplace, con un parámetro 'login success' le indica a mobiloud
            // que el usuario se logueo correctamente
            //this.router.navigate(['/market'], { queryParams: { login: 'success' } });
            this.showPreLogin = false;
        }
    }
}
